<template>

<app-page>

	<app-page-head :title="title" back="Groups">

		<template v-if="$permission('edit')">

			<app-page-head-action :disabled="!isDirty" icon="undo" tooltip="Undo changes" v-on:click.native="onUndoClick" />
			<app-page-head-action :loading="is.saving" :disabled="!isDirty" icon="save" tooltip="Save changes" v-on:click.native="onSaveClick" />
			<app-page-head-action route="Group.Delete" v-if="!isNew && $canDelete" :disabled="isNew" :danger="true" icon="delete" tooltip="Delete" />

		</template>
		
	</app-page-head>

	<app-page-content :is-grown="true">

		<app-page-content-section :is-padded="true" is-divided="true">

			<app-input-text v-model="model.title" :validation="$v.model.title" label="Title" placeholder="Enter title" :maxlength="64" />
			<app-input-suggest v-model="model.category" :validation="$v.model.category" store="categories" image="icon" color="background" :show-all="true" label="Category" placeholder="Library" />
			<app-input-slug v-model="model.slug" :validation="$v.model.slug" :source="model.title" label="Slug" placeholder="Enter slug" :maxlength="64" />
			<app-input-image v-model="model.image" :validation="$v.model.image" label="Thumbnail" />
			<app-input-toggle v-model="model.visible" label="Visible" />
			<app-input-toggle v-model="model.searchable" label="Searchable" />
			<app-input-tags v-model="model.terms" :dynamic-tag="model.title" label="Terms" />
			<app-input-toggle v-model="model.format" label="Content" :full-width="true" :options="contentOptions" />
			<app-input-select v-model="model.template" label=" " :validation="$v.model.template" placeholder="No template" :full-width="true" :options="templateOptions" v-if="model.format === 1" />

		</app-page-content-section>

		<app-page-content-section :is-padded="true" is-divided="true" :grow="true">

			<app-input-texts v-model="model.texts" :is-legacy="true" store="groups" route="Group.Text" v-if="model.format === 0" />

			<app-input-section v-model="model.content" v-if="model.format === 1" />

		</app-page-content-section>

		<app-page-content-link v-if="!isNew" is-divided="true" icon="items" title="Items" route="Group.Items" :params="{id: model.id}" :count="itemCount" />

	</app-page-content>

	<app-page-foot />

</app-page>

</template>

<script>

import mixForm from '@/mixin/form'
import { required, maxLength, minValue } from 'vuelidate/lib/validators'

export default {

	mixins: [mixForm],

	data: function() {

		return {
			contentOptions: {
				0: 'v1',
				1: 'v2'
			},
			model: {
				id: 0,
				slug: '',
				category: 0,
				title: '',
				image: '',
				template: 0,
				format: 0,
				visible: 1,
				searchable: 1,
				content: [],
				terms: [],
				texts: [],
				order: 0
			},
			param: 'group',
			noun: 'Group',
			store: 'groups',
			data: {},
			callbacks: [
				'textRemove',
				'textDelete',
				'textInsert',
				'textReplace'
			]
		}

	},

	validations: function() {

		var validations = {
			model: {
				title: {
					required,
					maxLength: maxLength(64)
				},
				slug: {
					required
				},
				category: {
					required,
					minValue: minValue(0)
				},
				image: {
					required
				}
			}
		}

		if (this.model.format === 2) {

			validations.model.template = {
				required,
				minValue: minValue(1)
			}

		}

		return validations

	},

	watch: {

		template: function(n) {

			if (this.is.loading) return

			if (n) {

				var template = this.$_.findWhere(this.data.templates, {
					id: n
				})

				if (template) {
					
					this.model.content = template.content

				} else {

					this.model.content = []

				}

			} else {

				this.model.content = []

			}

		}

	},

	computed: {

		template: function() {

			return this.model.template

		},

		templateOptions: function() {

			var templates = {
				0: 'No template'
			}

			this.$_.each(this.data.templates, function(template) {

				templates[template.id] = template.name

			})

			return templates

		},

		texts: function() {

			return this.$store.getters['texts/find/index'](this.model.texts)

		},

		itemCount: function() {

			return this.$store.getters['items/find/group'](this.model.id).length

		}

	},

	methods: {
		
		load: function() {

			this.is.loading = true

			return this.$api.get(['group', this.$route.params.group]).then(function(response) {

                this.$vueset(this, 'data', this.$util.clone(response))

				this.is.loading = false

			}.bind(this))

		},

		default: function() {

			if (this.$route.params.parent) this.model.category = this.$route.params.parent

		},

		textRemove: function(id) {

			this.model.texts.splice(this.model.texts.indexOf(id), 1)

		},

		textInsert: function(e) {

			this.model.texts.splice(e.position, 0, e.id)

			console.log(this.model.texts, e)

		},

		textReplace: function(e) {

			this.model.texts[this.model.texts.indexOf(e.from)] = e.to

		},

		textDelete: function(id) {

			this.model.texts.splice(this.model.texts.indexOf(id), 1)
			if (this.original.texts.indexOf(id) !== -1) this.original.texts.splice(this.original.texts.indexOf(id), 1)

		}

	}

}

</script>

<style scoped>

</style>
